export default __webpack_public_path__ + "static/media/oil&gas.ccfad788.jpg";